//#region import libraries
import React, { useEffect, useState } from 'react';

// redux
import { useSelector, useDispatch } from 'react-redux';
import { selectAdditionalPassengers, setAdditionalPassengers } from '_redux/slices/prm-bookings/bookings';
import { resetAdditionalPassengers, selectDuplicatedCombinedBookings, selectTimelineDeparturesBookingList, setDuplicatedCombinedBookings, selectBookingsByFlight, setBookingLocation } from "_redux/slices/timeline/timeline-data";
import { resetPostBookings, selectPostedBookingsError, selectPostedBookingsStatus, selectAddFlightPassengerStatus, selectAddFlightPassengerError, resetAddFlightPassenger, selectAddFlightPassengerNeedsDepartureDate, selectAddFlightPassengerBookings } from '_redux/slices/timeline/timeline-bookings';

import { selectDefaultCheckInLocation } from '_redux/slices/timeline/timeline-control';
import { selectPickUpLocations } from '_redux/slices/timeline/timeline-areas';
import { selectFirebaseUser, selectIata, selectUserDb } from '_redux/slices/main-screen/user';
import { selectUsedTheme } from '_redux/slices/timeline/theme';

// CUSTOM COMPONENTS
import { CustomSpinner, Label } from '_atoms';
import { AssistanceSelector } from '_molecules';

// bootstrap
import { Form, Button, Alert } from 'react-bootstrap';

// icon
import { MdError } from 'react-icons/md';
import { HiOutlineInformationCircle } from 'react-icons/hi';

// styling
import { Colors } from "_styles";

// drop down menu
import Select from "react-select";

//#endregion

//#region pax info
const PassengerInformationForm = ({ passenger, index, setFirstName, setSecondName, setAssistance, setPickUpLocation, pickUpLocations, flightType, setErrorMessage, setAmbiliftRequired }) => {

    const defaultCheckInLocation = useSelector(selectDefaultCheckInLocation);                     //Defaul checkIn location...
    const usedTheme = useSelector(selectUsedTheme);
    const iata = useSelector(selectIata)
    const assistanceTooltip = "The assistance is optional, to start the task agent must update task with required assistance.",
        paaxNameTooltip = "First name and second name are optional,to start the task agent must update task with passenger name ";

    // check if there is a defaultCheckInLocation setSelectedPickUp by default as the defaultCheckInLocation
    const [selectedPickUp, setSelectedPickUp] = useState(null)

    const [validInput, setValidInput] = useState(false);    // true if name, assistance is valid
    useEffect(() => {
        if (defaultCheckInLocation) {
            const tempLocation = pickUpLocations?.find(loc => loc?._id === defaultCheckInLocation)
            setSelectedPickUp({
                value: tempLocation?._id ?? "",
                label: tempLocation?.title ?? ""
            })
            setPickUpLocation(defaultCheckInLocation, index)
        };
    }, []);

    useEffect(() => {


        // check for valid first name and last name and assistance
        if (passenger?.firstName && passenger?.firstName.length != 0 && passenger?.secondName && passenger?.secondName.length !== 0) {
            // check assistance
            if (Array.isArray(passenger?.assistance) && passenger?.assistance.length > 0) {
                setValidInput(true);
                setErrorMessage(null);
            }
            else {
                // invalid assistance
                setValidInput(false);
                setErrorMessage("Assistance is required to add passenger.");
            }
        }
        else {
            setValidInput(false);
            // show error message
            setErrorMessage("First name, second name and assistance are required to add passenger.");
        }

    }, [passenger])


    const handleChangeName = (type, inputValue, key) => {

        const nameRegex = /^[A-Za-zÀ-ÖØ-öø-ÿ' -]+$/;

        //Validate and set field-specific error
        let msg = "";
        if (inputValue.trim() === "") {
            msg = "This field is required";
        } else if (!nameRegex.test(inputValue)) {
            msg = "Name must only contain letters, spaces, hyphens, and apostrophes";
        }

        if (type === "firstName") setFirstName(inputValue, key);

        if (type === "secondName") setSecondName(inputValue, key)
        setErrorMessage(msg)
    }

    return (
        <div key={index}>

            {/* styling */}
            <style>
                {`
                    .form-input::placeholder {
                    color: ${usedTheme.TEXT_COLOR} !important;
                    opacity: 1;
                    }
                `}
            </style>

            <div key={index} style={{ display: "grid" }}>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <div style={{ width: "100%" }}>

                        {/* first name + last name */}
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <div style={{ width: "45%" }}>
                                <Label>First Name <span data-tippy-content={paaxNameTooltip}  ><HiOutlineInformationCircle size={20} color="#307FE2" /></span></Label>
                                <Form.Control className="form-input" type="text" placeholder="Passenger first name" onChange={(e) => handleChangeName("firstName", e.target.value, index)} value={passenger?.firstName}
                                    style={{ backgroundColor: usedTheme.BACKGROUND_COLOR, borderColor: usedTheme.BORDER_COLOR, color: usedTheme.TEXT_COLOR }} />
                            </div>

                            <div style={{ width: "45%" }}>
                                <Label>Second Name <span data-tippy-content={paaxNameTooltip}  ><HiOutlineInformationCircle size={20} color="#307FE2" /></span></Label>
                                <Form.Control className="form-input" type="text" placeholder="Passenger second name" onChange={(e) => handleChangeName("secondName", e.target.value, index)} value={passenger?.secondName}
                                    style={{ backgroundColor: usedTheme.BACKGROUND_COLOR, borderColor: usedTheme.BORDER_COLOR, color: usedTheme.TEXT_COLOR }} />
                            </div>
                        </div>

                        {/* Assistance selector */}
                        <div className='mt-5'>
                            <Label>Assistance <span data-tippy-content={assistanceTooltip}  ><HiOutlineInformationCircle size={20} color="#307FE2" /></span></Label>
                            <AssistanceSelector setAssistance={(e) => { setAssistance(e, index) }} defaultValue={[]} value={passenger?.assistance} />
                        </div>
                        {iata === "PUJ" && <div className='mt-5'>
                            <Label>Ambilift Required</Label>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 4 }}>
                                <Form.Check
                                    type="switch"
                                    onChange={(e) => { setAmbiliftRequired(e.target.checked, index) }}
                                    checked={!!passenger?.ambiliftRequired}
                                />
                                <span style={{ fontSize: 13, color: passenger?.ambiliftRequired ? Colors.DARK_GREEN : Colors.GRAY_DARK, fontWeight: 500 }}>
                                    {passenger?.ambiliftRequired ? 'Yes' : 'No'}
                                </span>
                            </div>
                        </div>}

                        {/* Pick up locations, in case departure flight */}
                        {/* commented out until added to V2 APIs */}

                        {(flightType === "departure" || flightType === "boarding") && (
                            <div className='mt-5 d-grid'>
                                <Label>Pick Up Location (Optional)</Label>
                                <Select
                                    value={selectedPickUp || null}
                                    onChange={(selectedOption) => {
                                        setSelectedPickUp(selectedOption);
                                        setPickUpLocation(selectedOption?.value, index);
                                    }}
                                    options={pickUpLocations?.map(loc => ({
                                        value: loc._id,
                                        label: loc.title
                                    }))}
                                    placeholder="Choose Pick Up Location..."
                                    // menuPortalTarget={document.body}
                                    menuPosition="fixed"
                                    maxMenuHeight={240}
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            minWidth: "25%",
                                            borderRadius: "5px",
                                            backgroundColor: usedTheme.BACKGROUND_COLOR,
                                            borderColor: usedTheme.BORDER_COLOR,
                                            color: usedTheme.TEXT_COLOR,
                                        }),
                                        placeholder: (provided) => ({
                                            ...provided,
                                            color: usedTheme.TEXT_COLOR,
                                        }),
                                        singleValue: (provided) => ({
                                            ...provided,
                                            color: usedTheme.TEXT_COLOR,
                                        }),
                                        menu: (provided) => ({
                                            ...provided,
                                            backgroundColor: usedTheme.BACKGROUND_COLOR,
                                            borderColor: usedTheme.BORDER_COLOR,
                                            color: usedTheme.TEXT_COLOR,
                                            zIndex: 9999
                                        }),
                                        menuPortal: (provided) => ({
                                            ...provided,
                                            zIndex: 9999
                                        }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused
                                                ? usedTheme.BORDER_COLOR
                                                : usedTheme.BACKGROUND_COLOR,
                                            color: usedTheme.TEXT_COLOR,
                                            cursor: 'pointer',
                                        }),
                                    }}
                                    isClearable
                                />
                            </div>
                        )}
                    </div>

                </div>

            </div>
        </div>
    )
}
//#endregion

//#region add pax
const AdditionalPassengerForm = (props) => {

    //#region redux
    const dispatch = useDispatch();

    // usr
    const firebaseUser = useSelector(selectFirebaseUser);

    const additionalPassengers = useSelector(selectAdditionalPassengers);                               // additional Passengers to be added to flight 
    const postedBookingStatus = useSelector(selectPostedBookingsStatus)                                 // status of post request
    const pickUpLocations = useSelector(selectPickUpLocations);                                         // list of pick up locations        
    const postBookingError = useSelector(selectPostedBookingsError);                                   // error message from post request                 
    const addFlightPassengerStatus = useSelector(selectAddFlightPassengerStatus);                       // status of addFlightPassenger request
    const addFlightPassengerError = useSelector(selectAddFlightPassengerError);                         // error message from addFlightPassenger request
    const needsDepartureDate = useSelector(selectAddFlightPassengerNeedsDepartureDate);                 // true when 422 is returned
    const duplicatedCombinedBookings = useSelector(selectDuplicatedCombinedBookings);                   // list of duplicated bookings
    const timelineDeparturesBookingList = useSelector(selectTimelineDeparturesBookingList);             // list of all departure bookings in timeline
    const allBookingsByFlight = useSelector((state) => selectBookingsByFlight(state, true))    //#endregion
    const usedTheme = useSelector(selectUsedTheme);
    const flightPassengerbookings = useSelector(selectAddFlightPassengerBookings)
    //#region local state
    const [errorMessage, setErrorMessage] = useState(null);                 // holds error message
    const [additionalBoard, setAdditionalBoard] = useState(false);          // additional boarding or only boarding
    const [departureDate, setDepartureDate] = useState('');                 // departure date for arrival flights
    const [showDepartureDateField, setShowDepartureDateField] = useState(false); // show departure date field
    const [addWithNoName, setAddWithNoName] = useState(false); // add passengers with no name
    //#endregion

    //#region form handlers 

    //#region passenger name
    useEffect(() => {
        dispatch(resetPostBookings())
        dispatch(resetAddFlightPassenger())
    }, [])

    // save first name in the pax object 
    const setFirstName = (value, index) => {
        let tempList = [...additionalPassengers];                                       // copy list
        const newObj = Object.assign({}, tempList[index], { firstName: value });        // create a new object with a writable firstName property
        tempList[index] = newObj;                                                       // update list with new object
        dispatch(setAdditionalPassengers(tempList))
    }

    // save last name in pax object
    const setSecondName = (value, index) => {
        let tempList = [...additionalPassengers];                                        // copy list
        const newObj = Object.assign({}, tempList[index], { secondName: value });        // create a new object with a writable secondName property
        tempList[index] = newObj;                                                       // update list with new object
        dispatch(setAdditionalPassengers(tempList))
    }
    //#endregion

    //#region assistance handling

    // save selected assistance as assistance key
    const setAssistance = (value, index) => {
        let tempList = [...additionalPassengers];                                         // copy list
        const newObj = Object.assign({}, tempList[index], { assistance: value });        // create a new object with a writable assistance property
        tempList[index] = newObj;                                                       // update list with new object
        dispatch(setAdditionalPassengers(tempList))

    }
    //#endregion

    //#region Ambilift Required handling
    // save ambiliftRequired as ambiliftRequired key
    const setAmbiliftRequired = (value, index) => {
        let tempList = [...additionalPassengers];
        const newObj = Object.assign({}, tempList[index], { ambiliftRequired: value });
        tempList[index] = newObj;
        dispatch(setAdditionalPassengers(tempList))
    }

    //#endregion

    //#region pick up location      
    // add locationInfo into pax object
    const setPickUpLocation = (value, index) => {
        // check if there is no value the remove locationInfo from teh passenger object
        if (!value) {
            let tempList = [...additionalPassengers];               // copy list
            let newObj = Object.assign({}, tempList[index]);        // create a new object with a writable locationInfo property
            if (newObj?.locationInfo) delete newObj?.locationInfo;
            tempList[index] = newObj;                               // update list with new object
            dispatch(setAdditionalPassengers(tempList))
        } else {
            const locationInfo = {
                locationId: value,
                locationTitle: pickUpLocations?.find((pickUp) => value == pickUp?._id)?.title,
                activity: "Checked-in",
                time: new Date()
            }
            let tempList = [...additionalPassengers]; // copy list
            const newObj = Object.assign({}, tempList[index], { locationInfo });        // create a new object with a writable locationInfo property
            tempList[index] = newObj; // update list with new object
            dispatch(setAdditionalPassengers(tempList))
        }
    }
    //#endregion

    //#region duplicate booking
    const handleDuplicate = () => {
        // find flight in allBookingsByFlight for the current flight
        let wantedFlightKey = props?.flight?.replace('_', '/boarding_');
        const targetKey = Object?.keys(allBookingsByFlight)?.find(key => key.startsWith(wantedFlightKey));

        // filter allBookingsByFlight for the current flight and that is not duplicateVersion
        let filteredBooking = allBookingsByFlight?.[targetKey]?.filter((booking) => !booking?.duplicateVersion)?.[0];
        // check if filteredBooking is an object
        if (!Object.isObjectEmpty(filteredBooking)) {
            let tempBooking = { ...filteredBooking }
            let originalCombinedBookingList = Array.isFullArray(duplicatedCombinedBookings) ? [...duplicatedCombinedBookings] : []
            let duplicateVersion = 1;           // initally, all duplicates are part-1

            // use duplicate list to count number of duplicates for this boarding pass
            if (duplicatedCombinedBookings && duplicatedCombinedBookings.length > 0) {
                let tempDuplicates = duplicatedCombinedBookings.filter(item => item.doc._id.startsWith(tempBooking._id));
                if (tempDuplicates && tempDuplicates.length > 0) {
                    duplicateVersion = tempDuplicates.length + 1;
                }
            }

            tempBooking.duplicateVersion = duplicateVersion;

            let newId = tempBooking._id + "-part" + duplicateVersion;

            let newDuplicate = { doc: tempBooking, id: newId };
            newDuplicate.doc._id = newId;

            originalCombinedBookingList.push(newDuplicate);
            dispatch(setDuplicatedCombinedBookings(originalCombinedBookingList));
        };
    }
    //#endregion

    //save pax after clicking add passsenger
    const handleAddBooking = () => {
        // If departure date is required but not provided, show error
        if (showDepartureDateField && !departureDate) {
            setErrorMessage("Please select a departure date to complete adding this booking.");
            return;
        }
        // check if there is a first name and last name and assistance
        props?.addBooking(additionalBoard, departureDate);
    }

    // handle complete from app
    const handleAddWithNoNameSwitch = () => {
        setAddWithNoName(!addWithNoName);
        dispatch(resetPostBookings())
        dispatch(resetAddFlightPassenger())
        dispatch(resetAdditionalPassengers())
        dispatch(setAdditionalPassengers([{ firstName: "", secondName: "", assistance: [], locationInfo: {} }]))

    }

    const handleCheckin = () => {
        const bookingId = flightPassengerbookings[0]?._id || flightPassengerbookings[0]?.id;
        const locationInfo = additionalPassengers[0]?.locationInfo
        if (!locationInfo || !locationInfo.locationId || !bookingId) {
            dispatch(resetAddFlightPassenger())
            return; // if there is no location info or location id, return
        }
        const object = {
            bookingId,
            location: locationInfo.locationId,
            locationTitle: locationInfo.locationTitle,
            activity: "Checked-in",
            time: new Date(),
            setBy: {
                id: firebaseUser?.uid ?? "",
                name: firebaseUser?.displayName ?? "",
                from: "portal",
                time: new Date(),
            }
        };
        dispatch(setBookingLocation(object))
        dispatch(resetAddFlightPassenger())

    }
    //#endregion

    //#region useEffect
    // reset
    useEffect(() => {
        dispatch(resetAdditionalPassengers());
    }, []);

    // handle duplicate on success
    useEffect(() => {
        if ((postedBookingStatus === "succeeded" || addFlightPassengerStatus === "succeeded") && (additionalBoard === "additionalBoarding" || additionalBoard === "onlyBoarding")) {
            handleDuplicate();
        }
    }, [postedBookingStatus, addFlightPassengerStatus, additionalBoard, timelineDeparturesBookingList]);

    // handling error message from postBookingList
    useEffect(() => {
        if (postedBookingStatus === "failed" && postBookingError) {
            setErrorMessage(postBookingError)
        }
    }, [postedBookingStatus]);

    // handling error message from addFlightPassenger
    useEffect(() => {
        if (addFlightPassengerStatus === "failed" && addFlightPassengerError) {
            setErrorMessage(addFlightPassengerError)
        }
        if (addFlightPassengerStatus === "succeeded") {
            //handle check-in for added passenger if location is not null
            handleCheckin()
        }
    }, [addFlightPassengerStatus]);

    // Show departure date field when 422 is returned (needs departure date)
    useEffect(() => {
        if (needsDepartureDate && addFlightPassengerStatus === 'needs_departure_date') {
            setShowDepartureDateField(true);
            setErrorMessage(null); // Clear error since we're showing the field
        }
    }, [needsDepartureDate, addFlightPassengerStatus]);

    // Reset departure date field when form is reset
    useEffect(() => {
        return () => {
            setDepartureDate('');
            setShowDepartureDateField(false);
        };
    }, []);

    //#endregion


    return (
        <div style={{ display: "grid" }}>

            {/* pax name + assistance + pick-up locations */}
            {additionalPassengers?.map((passenger, index) => {
                return (
                    <PassengerInformationForm
                        passenger={passenger}
                        index={index}
                        setFirstName={setFirstName}
                        setSecondName={setSecondName}
                        setAssistance={setAssistance}
                        setPickUpLocation={setPickUpLocation}
                        pickUpLocations={pickUpLocations}
                        flightType={props.type}
                        setErrorMessage={setErrorMessage}
                        setAmbiliftRequired={setAmbiliftRequired}
                        key={index}
                    />
                )
            })
            }

            {/* Not complete passengers */}
            <div className='mt-4' style={{ display: 'flex', flexDirection: 'column' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ fontSize: '16px', color: 'gray', fontWeight: '500' }}>
                        Add with No Name
                    </span>
                    <Form.Check
                        onChange={handleAddWithNoNameSwitch}
                        type="switch"
                        checked={addWithNoName}
                        value={addWithNoName}
                        style={{ marginLeft: "16px" }}
                    />
                </div>
                <span style={{ color: usedTheme.TEXT_COLOR, fontSize: '14px', marginTop: '4px' }}>
                    Add passengers with no name and assistance to be completed by the staff from the app.
                </span>
            </div>

            {/* Boarding options */}
            {/* {dbUser && dbUser.details && dbUser.details?.authority != 'JER' && (props.type === "departure" || props.type === "boarding") ?
                <Form className='mt-5'>
                    <Form.Label className="m-0" style={{ color: Colors.PRM_LIGHT_BLUE }}>Boarding Options</Form.Label>
                    <div style={{}}>
                        <div className='d-flex align-items-center'>
                            <Form.Check inline type="radio" checked={additionalBoard == "additionalBoarding"} onChange={() => setAdditionalBoard("additionalBoarding")} />
                            <Form.Check.Label style={{ marginTop: ".25em" }}>Additional Boarding</Form.Check.Label>
                        </div>
                        <div className='d-flex align-items-center'>
                            <Form.Check inline type="radio" checked={additionalBoard == "onlyBoarding"} onChange={() => setAdditionalBoard("onlyBoarding")} />
                            <Form.Check.Label style={{ marginTop: ".25em" }}>Only Boarding</Form.Check.Label>
                        </div>
                        <div className='d-flex align-items-center'>
                            <Form.Check inline type="radio" checked={additionalBoard == ""} onChange={() => setAdditionalBoard("")} />
                            <Form.Check.Label style={{ marginTop: ".25em" }}>None</Form.Check.Label>
                        </div>
                    </div>
                </Form>
                : null} */}

            {/* Departure Date Field - shown when required for arrival flights */}
            {showDepartureDateField && (
                <div className='mt-4'>
                    <Alert variant="warning" style={{ borderRadius: 8, fontSize: 13 }}>
                        <HiOutlineInformationCircle size={18} style={{ marginRight: 6 }} />
                        Flight schedule not found. Select the flight&apos;s true departure date. Overnight arrivals often depart the previous calendar day.
                    </Alert>
                    <Form.Group className='mt-3'>
                        <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE, fontWeight: 500 }}>
                            Departure Date <span style={{ color: 'red' }}>*</span>
                        </Form.Label>
                        <Form.Control
                            type="date"
                            value={departureDate}
                            min={(() => {
                                const yesterday = new Date();
                                yesterday.setDate(yesterday.getDate() - 1);
                                return yesterday.toISOString().split('T')[0];
                            })()}
                            max={(() => {
                                const tomorrow = new Date();
                                tomorrow.setDate(tomorrow.getDate() + 1);
                                return tomorrow.toISOString().split('T')[0];
                            })()}
                            onChange={(e) => {
                                setDepartureDate(e.target.value);
                                setErrorMessage(null);
                            }}
                            style={{
                                borderRadius: 8,
                                borderColor: !departureDate && errorMessage ? Colors.DARK_RED : Colors.GRAY_MEDIUM
                            }}
                        />
                        <p style={{ color: Colors.GRAY_DARK, fontSize: 12, marginTop: 4, marginBottom: 0 }}>
                            Use the date the aircraft departed its origin airport, not the local arrival date.
                        </p>
                    </Form.Group>
                </div>
            )}

            {/* Adding passenger button */}
            <div className='mt-5' style={{ display: "flex", justifyContent: "center" }}>
                <Button variant="outline-primary" onClick={handleAddBooking} style={{ width: 200 }} disabled={(!addWithNoName && errorMessage) || props.loading}>
                    {(postedBookingStatus === "loading" || addFlightPassengerStatus === "loading" || props.loading) ? <CustomSpinner size={'small'} variant={'light'} /> : "Add Passenger"}
                </Button>
            </div>
            {(!addWithNoName && errorMessage) && <div style={{ display: 'flex' }}><MdError color={'red'} size={22} /><p style={{ color: 'red' }}>{errorMessage}</p></div>}

        </div>
    );

};
//#endregion

export default AdditionalPassengerForm;